import Box from '@mui/material/Box';

import { MembershipActivityFragment } from '@occc/graphql';

import { Typography } from '@occc-app/design-system';

import { EmptyValue } from '@occc/ui-design-system';

import { getOfferName, getSource } from '../membership-activity.utils';

type MembershipActivitySourceProps = {
  activity: MembershipActivityFragment;
};

export const MembershipActivitySource = ({ activity }: MembershipActivitySourceProps) => {
  const source = getSource(activity);
  const offerName = getOfferName(activity);

  return (
    <Box component='span' display='block'>
      <Typography component='span' variant='body2' display='block'>
        {source || <EmptyValue />}
      </Typography>
      {offerName && (
        <Typography component='span' variant='caption' color='text.secondary' display='block'>
          {offerName}
        </Typography>
      )}
    </Box>
  );
};
